module.exports = __webpack_public_path__ + "static/img/leiniao-benefit-video_new.a762b14e.png";